import { render } from "./QuotationPricingDetails.vue?vue&type=template&id=ec817e5e"
import script from "./QuotationPricingDetails.vue?vue&type=script&lang=js"
export * from "./QuotationPricingDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__